import { useRef, useState } from "react";
import useHandleOutside from "@/hooks/useHandleOutside";
import Arrow from "@/components/icons/Arrow";
import { useRouter } from "next/router";

const Sort = ({ filters, selectedFilters, handleFilterChange, tab, t }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const ref = useRef();
  const { locale } = useRouter();
  useHandleOutside(ref, () => setOpenDropdown(null));
  const currentFilters = filters?.[tab] || {};
  const filterOptions = [
    {
      key: "category_filter",
      label: locale === "ar" ? "الفئات" : "categories",
      values: currentFilters?.categories || [],
    },
    {
      key: "price",
      label: locale === "ar" ? "السعر" : "prices",
      values: currentFilters?.prices || [],
    },
    {
      key: "brand",
      label: locale === "ar" ? "العلامة التجارية" : "brands",
      values: currentFilters?.brands || [],
    },
  ];

  const handleDropdownToggle = (key) => {
    setOpenDropdown((prev) => (prev === key ? null : key));
  };
  console.log("selectedFilters", selectedFilters);

  return (
    <div className="flex flex-wrap items-center gap-4 pb-2 max-sm:grid max-sm:grid-cols-1 max-sm:gap-2">
      {filterOptions.map(
        ({ key, label, values }) =>
          values?.length > 0 && (
            <div key={key} className="relative">
              <div
                onClick={() => handleDropdownToggle(key)}
                className="flex items-center justify-between gap-2 px-2 py-1 text-gray-700 border rounded cursor-pointer md:py-2 min-w-40 max-sm:min-w-full"
              >
                <span className="text-sm font-bold cursor-pointer">
                  {t(label)}
                </span>
                <Arrow className="cursor-pointer size-3" />
              </div>

              {openDropdown === key && (
                <ul
                  ref={ref}
                  className="absolute z-50 w-full p-2 overflow-y-auto bg-white border rounded-md shadow-lg max-h-40 gray-scrollbar top-full start-0"
                >
                  {values.length > 0 ? (
                    values.map((item, idx) => (
                      <li
                        key={idx}
                        className="hover:text-secondary-700 *:cursor-pointer cursor-pointer text-sm last:mb-0 mb-2 flex items-center gap-1"
                      >
                        <input
                          onClick={() => handleFilterChange(key, item?.Key)}
                          type="checkbox"
                          className={`border rounded-sm appearance-none size-3 checked:border-secondary-700 checked:bg-secondary-700 ${
                            selectedFilters[key].includes(item?.Key)
                              ? "bg-secondary-700 border-secondary-700"
                              : ""
                          }`}
                          id={item?.Key + item?.Label}
                        />
                        <label htmlFor={item?.Key + item?.Label}>
                          {t(item?.Label)}
                        </label>
                      </li>
                    ))
                  ) : (
                    <li className="text-sm text-center text-gray-500">
                      {"no_options_available"}
                    </li>
                  )}
                </ul>
              )}
            </div>
          )
      )}
    </div>
  );
};

export default Sort;
